import { userService } from 'ogp/services';
import { useMutation } from 'react-query';

export const useResendTemporaryPassword = () => {
  const mutationFn = async (email: string) => await userService.resendTemporaryPassword(email);

  return useMutation(mutationFn);
};
